 import ViewGroups from './ViewGroups';

export default ViewGroups;
